import { Admin } from "@/api/models/admin/Admin";
import { defineStore } from "pinia";
import { AdminService } from "@/api/services/AdminService";

export const adminStore = defineStore("admin", {
  state: (): Admin => ({
    id: 0,
    account: "",
    create_at: "",
    update_at: "",
    is_delete: 0,
  }),
  getters: {},
  actions: {
    async getLoginUser() {
      const res = await AdminService.Get();
      if (res.code === 0 && res.data != undefined) {
        /**
         * 从 API 响应中获取的数据
         */
        const adminData: Partial<Admin> = res.data;

        /**
         * 使用对象解构赋值更新状态对象的属性
         */
        Object.assign(this, adminData);
      }
    },
  },
});
